import { FormMatrixTableDataModel } from "../../../../../../../data-model/tablesData";
import { FormMatrixTableColumnKeys } from "../../../../../../../enums/tableColumnKeys";
import type { FormMatrixConfigItem } from "../hooks/useFormMatrixData";

export const FIELD_TO_COLUMN_KEY: Record<
  keyof FormMatrixConfigItem,
  keyof FormMatrixTableDataModel
> = {
  form_name: FormMatrixTableColumnKeys.FORM_NAME,
  icd: FormMatrixTableColumnKeys.ICD,
  dosage: FormMatrixTableColumnKeys.DOSAGE,
  dosage_instr: FormMatrixTableColumnKeys.DOSAGE_INSTR,
  ev: FormMatrixTableColumnKeys.EV,
  daw: FormMatrixTableColumnKeys.DAW,
  review_needed: FormMatrixTableColumnKeys.REVIEW_NEEDED,
};

export const TOGGLE_SUFFIX_TO_FIELD: Record<
  string,
  keyof FormMatrixConfigItem
> = {
  icd: "icd",
  dosage: "dosage",
  dosageInstr: "dosage_instr",
  ev: "ev",
  daw: "daw",
  reviewNeeded: "review_needed",
};
